<template>
  <div class="corner" :class="'corner-'+i">
    <div class="img1" :style="{'background-color': corner.color }">
      <img :src="corner.img" alt="">
    </div>

    <div class="img2" :style="{'background-color': nextImg.color }">
      <img :src="nextImg.img" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      images: Array,
      corner: Object,
      i: Number
    },
    created() {
      this.iteration = (Number(this.i) + 1) % 4;
    },
    data() {
      return {
        iteration: null,
        timeline: null
      }
    },
    computed: {
      nextImg() {
        return this.images[this.iteration % 4];
      }
    },
    mounted() {
      let self = this;
      let timeline = anime.timeline({
        complete() {
          if (self.iteration < 8) {
            timeline.restart();
          }
        }
      }).add({
        targets: '.corner-' + self.i + ' .img1',
        delay: 100,
        duration: 350,
        opacity: [1, 0],
        easing: 'linear',
        complete() {
          let newImage = self.nextImg;
          self.corner.img = newImage.img;
          self.corner.color = newImage.color;
        }
      }).add({
        targets: '.corner-' + self.i + ' .img1' ,
        delay: 100,
        duration: 350,
        opacity: [0, 1],
        easing: 'linear',
        complete() {
          //console.log("hi");
          self.iteration += 1;
        }
      })

      this.timeline = timeline;
    }
  }
</script>

<style>

.img1, .img2 {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.img1 {
  z-index: 2;
}


</style>